import { InjectionToken, type Signal } from '@angular/core';

// Кто смотрит на пак: его id — единственная метка «мой пак» для правила видимости фонов. Порт не подан или
// id нет — зритель не владелец и видит у чужого пака только одобренные подложки (закрытый отказ).
export interface EditorViewer {
  userId: Signal<string | null>;
  /**
   * Рабочее место модерации: зритель видит фоны чужого пака со всеми вердиктами — иначе модератору нечего
   * одобрять. Подаёт хост (admin); кабинет фотографа флаг не подаёт, и лицензиат видит только одобренные.
   */
  seesAllVerdicts?: Signal<boolean>;
  /** The session is a super-admin: may write a foreign pack's narrative. Absent → not one. */
  superAdmin?: Signal<boolean>;
}

export const EDITOR_VIEWER = new InjectionToken<EditorViewer>('EDITOR_VIEWER');
